import { configureStore } from '@reduxjs/toolkit'
import navigationReducer from './navigation/slice'
import userReducer from './user/slice'
import reactionReducer from './reaction/slice'
import authorsReducer from './authors/slice'
import settingsReducer from './settings/slice'
import interestsReducer from './interests/slice'
import memberReducer from './member/slice'
import trackingReducer from './tracking/slice'
import notificationReducer from './notification/slice'
import categoryFilterReducer from './categoryFilter/slice'
import searchFilterReducer from './searchFilter/slice'
import signupReducer from './slices/signupSlice'
import categoriesReducer from './categories/slice'
import movieReducer from './movieSlice'
import suggestReducer from './suggest/slice'
import modalReducer from './modal/slice'
import roleModelFinderReducer from './roleModelFinderSlice'
import companiesReducer from './companies/slice'

export const store = configureStore({
  reducer: {
    navigation: navigationReducer,
    user: userReducer,
    reaction: reactionReducer,
    authors: authorsReducer,
    settings: settingsReducer,
    interests: interestsReducer,
    member: memberReducer,
    tracking: trackingReducer,
    notification: notificationReducer,
    categoryFilter: categoryFilterReducer,
    searchFilter: searchFilterReducer,
    signup: signupReducer,
    categories: categoriesReducer,
    movie: movieReducer,
    suggest: suggestReducer,
    modal: modalReducer,
    roleModelFinder: roleModelFinderReducer,
    companies: companiesReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
